import templateUrl from './subjectManagerPopup.html';
import controller from './subjectManagerPopup.controller';
import './subjectManagerPopup.scss';

const subjectManagerPopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default subjectManagerPopupComponent;
